module.exports = __webpack_public_path__ + "static/media/getfeedback-icon.cd1ec411.png";